import React from 'react';
import MaterialRadio from '@mui/material/Radio';
import {styled} from '@mui/material/styles';
import type {RadioProps as MaterialRadioProps} from '@mui/material/Radio';

export type RadioProps = Omit<MaterialRadioProps,
'disableElevation' |
'disableFocusRipple' |
'disableRipple' |
'centerRipple' |
'disableTouchRipple' |
'focusRipple' |
'TouchRippleProps' |
'color'
>;

const StyledRadio = styled(MaterialRadio)(({theme}) => ({
    height: '1.875rem',
    width: '2.125rem',
    color: theme.tokens.FuelColorBorderDark,
    marginLeft: theme.spacing(1),
    '&.Mui-focusVisible .MuiSvgIcon-root': {
        borderRadius: '50%',
        boxShadow: `0 0 0 0.125rem ${theme.tokens.FuelColorFocused}`
    },
    '&:hover': {
        backgroundColor: 'transparent'
    },
    '&.Mui-checked:hover': {
        backgroundColor: 'transparent'
    },
    boxSizing: 'border-box'
}));

export const Radio = React.forwardRef<any, RadioProps>(
    (
        {...props},
        ref
    ) => {
        return (
            <StyledRadio
                ref={ref}
                {...props}
            />
        );
    });

Radio.displayName = 'Radio';
